// extracted by mini-css-extract-plugin
module.exports = {"attributeLabel":"AttributeEditGroup_attributeLabel__EwpSW","attributeWrapper":"AttributeEditGroup_attributeWrapper__2RNBN"};